import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    forgotPassword: [],
    loading: false,
    error: null,
}

const forgotPasswordSlice = createSlice({
    name: "forgotPassword",
    initialState,
    reducers: {
        fetchforgotPasswordSuccess: (state, action) => {
            state.loading = false;
            state.forgotPassword = action.payload;
        },
        fetchforgotPasswordFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchforgotPasswordSuccess, fetchforgotPasswordFailure } = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
